import _regeneratorRuntime from "/home/deploy/fe/v9/tigo-home-activator-fe/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _objectSpread from "/home/deploy/fe/v9/tigo-home-activator-fe/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _asyncToGenerator from "/home/deploy/fe/v9/tigo-home-activator-fe/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import { decode as base64url } from '../../runtime/base64url.js';
import decrypt from '../../runtime/decrypt.js';
import { inflate } from '../../runtime/zlib.js';
import { JOSEAlgNotAllowed, JOSENotSupported, JWEInvalid } from '../../util/errors.js';
import isDisjoint from '../../lib/is_disjoint.js';
import isObject from '../../lib/is_object.js';
import decryptKeyManagement from '../../lib/decrypt_key_management.js';
import { encoder, decoder, concat } from '../../lib/buffer_utils.js';
import generateCek from '../../lib/cek.js';
import validateCrit from '../../lib/validate_crit.js';
import validateAlgorithms from '../../lib/validate_algorithms.js';

function flattenedDecrypt(_x, _x2, _x3) {
  return _flattenedDecrypt.apply(this, arguments);
}

function _flattenedDecrypt() {
  _flattenedDecrypt = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(jwe, key, options) {
    var _a, parsedProt, _protectedHeader, joseHeader, alg, enc, keyManagementAlgorithms, contentEncryptionAlgorithms, encryptedKey, resolvedKey, cek, iv, tag, protectedHeader, additionalData, plaintext, result;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (isObject(jwe)) {
              _context.next = 2;
              break;
            }

            throw new JWEInvalid('Flattened JWE must be an object');

          case 2:
            if (!(jwe.protected === undefined && jwe.header === undefined && jwe.unprotected === undefined)) {
              _context.next = 4;
              break;
            }

            throw new JWEInvalid('JOSE Header missing');

          case 4:
            if (!(typeof jwe.iv !== 'string')) {
              _context.next = 6;
              break;
            }

            throw new JWEInvalid('JWE Initialization Vector missing or incorrect type');

          case 6:
            if (!(typeof jwe.ciphertext !== 'string')) {
              _context.next = 8;
              break;
            }

            throw new JWEInvalid('JWE Ciphertext missing or incorrect type');

          case 8:
            if (!(typeof jwe.tag !== 'string')) {
              _context.next = 10;
              break;
            }

            throw new JWEInvalid('JWE Authentication Tag missing or incorrect type');

          case 10:
            if (!(jwe.protected !== undefined && typeof jwe.protected !== 'string')) {
              _context.next = 12;
              break;
            }

            throw new JWEInvalid('JWE Protected Header incorrect type');

          case 12:
            if (!(jwe.encrypted_key !== undefined && typeof jwe.encrypted_key !== 'string')) {
              _context.next = 14;
              break;
            }

            throw new JWEInvalid('JWE Encrypted Key incorrect type');

          case 14:
            if (!(jwe.aad !== undefined && typeof jwe.aad !== 'string')) {
              _context.next = 16;
              break;
            }

            throw new JWEInvalid('JWE AAD incorrect type');

          case 16:
            if (!(jwe.header !== undefined && !isObject(jwe.header))) {
              _context.next = 18;
              break;
            }

            throw new JWEInvalid('JWE Shared Unprotected Header incorrect type');

          case 18:
            if (!(jwe.unprotected !== undefined && !isObject(jwe.unprotected))) {
              _context.next = 20;
              break;
            }

            throw new JWEInvalid('JWE Per-Recipient Unprotected Header incorrect type');

          case 20:
            if (!jwe.protected) {
              _context.next = 29;
              break;
            }

            _protectedHeader = base64url(jwe.protected);
            _context.prev = 22;
            parsedProt = JSON.parse(decoder.decode(_protectedHeader));
            _context.next = 29;
            break;

          case 26:
            _context.prev = 26;
            _context.t0 = _context["catch"](22);
            throw new JWEInvalid('JWE Protected Header is invalid');

          case 29:
            if (isDisjoint(parsedProt, jwe.header, jwe.unprotected)) {
              _context.next = 31;
              break;
            }

            throw new JWEInvalid('JWE Protected, JWE Unprotected Header, and JWE Per-Recipient Unprotected Header Parameter names must be disjoint');

          case 31:
            joseHeader = _objectSpread({}, parsedProt, {}, jwe.header, {}, jwe.unprotected);
            validateCrit(JWEInvalid, new Map(), options === null || options === void 0 ? void 0 : options.crit, parsedProt, joseHeader);

            if (!(joseHeader.zip !== undefined)) {
              _context.next = 38;
              break;
            }

            if (!(!parsedProt || !parsedProt.zip)) {
              _context.next = 36;
              break;
            }

            throw new JWEInvalid('JWE "zip" (Compression Algorithm) Header MUST be integrity protected');

          case 36:
            if (!(joseHeader.zip !== 'DEF')) {
              _context.next = 38;
              break;
            }

            throw new JOSENotSupported('Unsupported JWE "zip" (Compression Algorithm) Header Parameter value');

          case 38:
            alg = joseHeader.alg, enc = joseHeader.enc;

            if (!(typeof alg !== 'string' || !alg)) {
              _context.next = 41;
              break;
            }

            throw new JWEInvalid('missing JWE Algorithm (alg) in JWE Header');

          case 41:
            if (!(typeof enc !== 'string' || !enc)) {
              _context.next = 43;
              break;
            }

            throw new JWEInvalid('missing JWE Encryption Algorithm (enc) in JWE Header');

          case 43:
            keyManagementAlgorithms = options && validateAlgorithms('keyManagementAlgorithms', options.keyManagementAlgorithms);
            contentEncryptionAlgorithms = options && validateAlgorithms('contentEncryptionAlgorithms', options.contentEncryptionAlgorithms);

            if (!(keyManagementAlgorithms && !keyManagementAlgorithms.has(alg))) {
              _context.next = 47;
              break;
            }

            throw new JOSEAlgNotAllowed('"alg" (Algorithm) Header Parameter not allowed');

          case 47:
            if (!(contentEncryptionAlgorithms && !contentEncryptionAlgorithms.has(enc))) {
              _context.next = 49;
              break;
            }

            throw new JOSEAlgNotAllowed('"enc" (Encryption Algorithm) Header Parameter not allowed');

          case 49:
            if (jwe.encrypted_key !== undefined) {
              encryptedKey = base64url(jwe.encrypted_key);
            }

            resolvedKey = false;

            if (!(typeof key === 'function')) {
              _context.next = 56;
              break;
            }

            _context.next = 54;
            return key(parsedProt, jwe);

          case 54:
            key = _context.sent;
            resolvedKey = true;

          case 56:
            _context.prev = 56;
            _context.next = 59;
            return decryptKeyManagement(alg, key, encryptedKey, joseHeader);

          case 59:
            cek = _context.sent;
            _context.next = 67;
            break;

          case 62:
            _context.prev = 62;
            _context.t1 = _context["catch"](56);

            if (!(_context.t1 instanceof TypeError)) {
              _context.next = 66;
              break;
            }

            throw _context.t1;

          case 66:
            cek = generateCek(enc);

          case 67:
            iv = base64url(jwe.iv);
            tag = base64url(jwe.tag);
            protectedHeader = encoder.encode((_a = jwe.protected) !== null && _a !== void 0 ? _a : '');

            if (jwe.aad !== undefined) {
              additionalData = concat(protectedHeader, encoder.encode('.'), encoder.encode(jwe.aad));
            } else {
              additionalData = protectedHeader;
            }

            _context.next = 73;
            return decrypt(enc, cek, base64url(jwe.ciphertext), iv, tag, additionalData);

          case 73:
            plaintext = _context.sent;

            if (!(joseHeader.zip === 'DEF')) {
              _context.next = 78;
              break;
            }

            _context.next = 77;
            return ((options === null || options === void 0 ? void 0 : options.inflateRaw) || inflate)(plaintext);

          case 77:
            plaintext = _context.sent;

          case 78:
            result = {
              plaintext: plaintext
            };

            if (jwe.protected !== undefined) {
              result.protectedHeader = parsedProt;
            }

            if (jwe.aad !== undefined) {
              result.additionalAuthenticatedData = base64url(jwe.aad);
            }

            if (jwe.unprotected !== undefined) {
              result.sharedUnprotectedHeader = jwe.unprotected;
            }

            if (jwe.header !== undefined) {
              result.unprotectedHeader = jwe.header;
            }

            if (!resolvedKey) {
              _context.next = 85;
              break;
            }

            return _context.abrupt("return", _objectSpread({}, result, {
              key: key
            }));

          case 85:
            return _context.abrupt("return", result);

          case 86:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[22, 26], [56, 62]]);
  }));
  return _flattenedDecrypt.apply(this, arguments);
}

export { flattenedDecrypt };
export default flattenedDecrypt;